import { render, staticRenderFns } from "./EncountersSummary.vue?vue&type=template&id=724286a4&"
import script from "./EncountersSummary.vue?vue&type=script&lang=js&"
export * from "./EncountersSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports